// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addon-button-wrap{
  border-radius: var(--radius-sm, 6px);
  border: 1px solid var(--14bis-Light, #0071BA);
  background: var(--Basic-White, #FFF);
  display: flex;
  min-height: 48px;
  padding: 6px 24px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  color: var(--14bis-Light, #0071BA);
  font-family: Open Sans variable, Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddonButton/AddonButton.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".addon-button-wrap{\n  border-radius: var(--radius-sm, 6px);\n  border: 1px solid var(--14bis-Light, #0071BA);\n  background: var(--Basic-White, #FFF);\n  display: flex;\n  min-height: 48px;\n  padding: 6px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  color: var(--14bis-Light, #0071BA);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
